module.exports = __webpack_public_path__ + "img/icon_map_8_off_101.f57f032c.png";